import {availableStates} from '@/helpers/availableStates'

export default function () {
    return {
        availableStates,
        currentTab: 0,
        success: null,
        user: {
            name: '',
            cnpj: '',
            cadastur: '',
            email: '',
            password: '',
            image: '',
            agencyCover: '',
            currentImage: '',
            agency: {
                picture: '',
                cover: '',
                description: '',
                city: '',
                state: ''
            },
        },
        customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
        croppingImage: null,
        showCropper: false,
        croppingModel: null,
    }
}
